import { IonChip, IonLabel, IonText } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setFilterByStatusModal } from "../../../store/documentsSignerList";
import { selectStatusFilter } from "../../../store/documentsSignerList/selectors/selectStatusFilter";

export const FilterStatusChip = () => {
  const statusFilter = useSelector(selectStatusFilter);
  const dispatch = useDispatch();
  return (
    <IonChip
      onClick={() => dispatch(setFilterByStatusModal(true))}
      outline
      color={statusFilter?.length ? "primary" : "medium"}
    >
      <IonLabel class="ion-text-nowrap">
        {statusFilter?.length ? (
          <IonText color="primary" style={{ fontWeight: 600 }}>
            <span>Estado: </span>
            {statusFilter?.map(
              (statusItem, index) =>
                statusItem.name + (statusFilter?.length === index + 1 ? "" : ", ")
            )}
          </IonText>
        ) : (
          <span>Estado: Todos</span>
        )}
      </IonLabel>
    </IonChip>
  );
};
